export default {
    namespaced: true,
    state: {
        user: JSON.parse(localStorage.getItem('adminUser')),
        doctortype: JSON.parse(localStorage.getItem('doctortype')),
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getdoctortype(state) {
            return state.doctortype;
        },
    },
    mutations: {
        loggedIn(state, user) {
            if (user.token) {
                localStorage.setItem('adminUser', JSON.stringify(user));
                state.user = user;
            }
        },
        loggedOut(state){
            localStorage.removeItem('adminUser');
            state.user = null;
        },
        DoctorType(state, doctortype) {
            localStorage.setItem('doctortype', JSON.stringify(doctortype));
            state.doctortype = doctortype;
        }

    },
    actions: {
        storeAdminUser({commit}, adminUser) {
            commit('loggedIn', adminUser);
        },
        logout({commit}){
            commit('loggedOut');
        },
        setdoctortype({commit}, doctortype) {
            commit('DoctorType', doctortype);
        },
    },
};
